import React from 'react';
import type {
  AlertDetailViewProps,
} from '@plerionhq/design-system';
import { withErrorBoundary } from '../../../hoc/withErrorBoundary';

const AlertDetails = withErrorBoundary(
  React.lazy(() => import('../../../micro-frontends/components/AlertDetails')),
);

export const AlertDetailView = (props: AlertDetailViewProps) => {
  return <AlertDetails {...props.data} />;
};
